import { Box, Heading, Image, Text } from '@zillow/constellation-10';

import { CREATE_LEASE_CONTENT } from '../constants';
import type { STEPS } from '../constants';

type Props = {
  step: (typeof STEPS)[keyof typeof STEPS] & string;
};

const CreateLease = ({ step }: Props) => {
  return (
    <div data-testid="CreateLease">
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center',
          width: '100%',
          backgroundColor: 'bg.softest',
          height: { base: '80px', md: '144px' },
        }}
        data-testid="CreateLeaseHero"
      >
        <Image src={CREATE_LEASE_CONTENT[step].HERO_IMAGE} alt={CREATE_LEASE_CONTENT[step].HERO_IMAGE_ALT} />
      </Box>

      <Box css={{ marginBottom: '400' }} />

      <Box data-testid="CreateLeaseContentContainer" css={{ marginBottom: '400' }}>
        <Heading level={4}>{CREATE_LEASE_CONTENT[step].HEADING}</Heading>

        <Box css={{ marginBottom: '400' }} />

        <Text asChild>
          <p>{CREATE_LEASE_CONTENT[step].BODY}</p>
        </Text>
      </Box>
    </div>
  );
};

export default CreateLease;
